import React, { useState } from 'react';
import styled from 'styled-components';

const ChecklistContainer = styled.div`
    background: linear-gradient(145deg, #1e2837 0%, #111827 100%);
    border-radius: 10px;
    padding: 12px 16px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    max-width: 420px;
    margin: 12px auto 0;
    text-align: left;
`;

const ChecklistTitle = styled.div`
    color: rgba(255, 255, 255, 0.7);
    font-size: 0.75rem;
    font-weight: 600;
    margin: 0 0 8px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;

const SlidesGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 3px 20px;
`;

const SlideItem = styled.div`
    display: flex;
    align-items: center;
    gap: 7px;
    padding: 2px 0;
    color: rgba(255, 255, 255, 0.8);
    font-size: 0.8rem;
`;

const SlideNumber = styled.span`
    background: rgba(96, 165, 250, 0.15);
    color: #60A5FA;
    width: 18px;
    height: 18px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.65rem;
    font-weight: 600;
    flex-shrink: 0;
`;

const DismissButton = styled.button`
    background: none;
    border: none;
    color: rgba(255, 255, 255, 0.35);
    cursor: pointer;
    font-size: 0.7rem;
    padding: 0;
    &:hover { color: rgba(255, 255, 255, 0.6); }
`;

const PITCH_SLIDES = [
    'Problem',
    'Solution',
    'How It Works',
    'Traction',
    'Competitive Advantage',
    'Business Model',
    'Market',
    'Team',
    'The Ask'
];

const InvestorPitchChecklist = () => {
    const [dismissed, setDismissed] = useState(false);

    if (dismissed) return null;

    return (
        <ChecklistContainer>
            <ChecklistTitle>
                Pitch Deck Checklist
                <DismissButton onClick={() => setDismissed(true)}>Hide</DismissButton>
            </ChecklistTitle>
            <SlidesGrid>
                {PITCH_SLIDES.map((slide, i) => (
                    <SlideItem key={slide}>
                        <SlideNumber>{i + 1}</SlideNumber>
                        {slide}
                    </SlideItem>
                ))}
            </SlidesGrid>
        </ChecklistContainer>
    );
};

export default InvestorPitchChecklist;
